
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';

interface NavbarProps {
  activeSection: string;
}

export default function Navbar({ activeSection }: NavbarProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  const handleAdminAccess = () => {
    if (user) {
      navigate('/admin/dashboard');
    } else {
      navigate('/login');
    }
  };

  const navItems = [
    { label: 'Início', href: '#hero' },
    { label: 'Antes e Depois', href: '#antes-depois' },
    { label: 'Tratamentos', href: '#tratamentos' },
    { label: 'Vídeos', href: '#videos' },
    { label: 'Depoimentos', href: '#depoimentos' },
    { label: 'Contato', href: '#contato' }
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex-shrink-0">
            <img
              src="https://static.readdy.ai/image/c613884721c0b6590a025a9d6892fb89/457808a8ae48aaa1390aecf44d721494.png"
              alt="Plennittá"
              className={`h-8 w-auto transition-all duration-300 ${isScrolled ? '' : 'brightness-0 invert'}`}
            />
          </div>

          <nav className="hidden md:flex items-center space-x-8">
            <a href="#hero" className="nav-link text-sm font-medium text-gray-700 hover:text-[#8B6F47] transition-colors duration-200 cursor-pointer">Início</a>
            <a href="#videos" className="nav-link text-sm font-medium text-gray-700 hover:text-[#8B6F47] transition-colors duration-200 cursor-pointer">Dicas e Procedimentos</a>
            <a href="#antes-depois" className="nav-link text-sm font-medium text-gray-700 hover:text-[#8B6F47] transition-colors duration-200 cursor-pointer">Antes e Depois</a>
            <a href="#tratamentos" className="nav-link text-sm font-medium text-gray-700 hover:text-[#8B6F47] transition-colors duration-200 cursor-pointer">Tratamentos Exclusivos</a>
            <a href="#depoimentos" className="nav-link text-sm font-medium text-gray-700 hover:text-[#8B6F47] transition-colors duration-200 cursor-pointer">Histórias de Transformação</a>
            <a href="#contato" className="nav-link text-sm font-medium text-gray-700 hover:text-[#8B6F47] transition-colors duration-200 cursor-pointer">Agende Sua Avaliação</a>
          </nav>

          <button
            onClick={handleAdminAccess}
            className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap cursor-pointer ${
              isScrolled
                ? 'text-gray-700 hover:text-[#915726]'
                : 'text-white/90 hover:text-white'
            }`}
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Área Administrativa
          </button>

          <button
            onClick={() => scrollToSection('contato')}
            className="hidden md:block px-6 py-2.5 bg-[#915726] text-white text-sm font-medium rounded-full hover:bg-[#7A3010] transition-all duration-300 whitespace-nowrap cursor-pointer"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Agende sua Consulta
          </button>
        </div>
      </div>
    </nav>
  );
}
